import React from 'react';
import { Table } from 'antd';
import { ColumnProps } from 'antd/es/table';
import intl from 'react-intl-universal';

import ContentBlock, { FormItem } from '@/components/Reservation/ContentBlock';
import { formatAreaMobileStr } from '@/components/BaseMobileInput/helper';
import { format2FullTimeStr } from '@/utils/date';
import { renderContent } from '@/utils';

import styles from './index.module.scss';

interface SubOrderInfo {
  recNo: string;
  roomTypeName: string;
  roomNo: string;
  expectedDepartureTime: number;
  occInfoList: { name: string }[];
}

export interface OrderRoomInfo {
  masterName: string;
  masterMobile: string;
  masterEmail: string;
  subOrders: SubOrderInfo[];
}

interface IProps {
  data: OrderRoomInfo;
}

// 表格列
const TableColumn: ColumnProps<SubOrderInfo>[] = [
  { title: intl.get('app_constants_room_type'), dataIndex: 'roomTypeName' },
  { title: intl.get('app_constants_room_no'), dataIndex: 'roomNo' },
  {
    title: intl.get('app_constants_occupant_name'),
    dataIndex: 'occInfoList',
    render: (list: SubOrderInfo['occInfoList']) => {
      let result: string;
      if (list && list.length) {
        result = list
          .map((item) => item.name)
          .filter(Boolean)
          .join(',');
      }
      return renderContent(result);
    },
  },
  {
    title: intl.get('app_reservation_etd_time'),
    dataIndex: 'expectedDepartureTime',
    render: format2FullTimeStr,
  },
];

const Index: React.FC<IProps> = (props) => {
  const { masterName, masterMobile, masterEmail, subOrders } = props.data || {};

  return (
    <ContentBlock
      title={intl.get('drawer_extension_picker_origin_room')}
      className={styles.roomInfoBlock}
    >
      <div>
        <FormItem label={intl.get('app_constants_master_name')}>{masterName}</FormItem>
        <FormItem label={intl.get('app_reservation_phone_number')}>
          {renderContent(masterMobile, formatAreaMobileStr)}
        </FormItem>
        <FormItem label={intl.get('reservation_booker_field_email_placeholder')}>
          {renderContent(masterEmail)}
        </FormItem>
      </div>
      <Table rowKey="recNo" columns={TableColumn} dataSource={subOrders || []} pagination={false} />
    </ContentBlock>
  );
};

export default Index;
